import type { CmpPracticeType, CmpTypeStyle } from './types';

export const GROWTH_COMPETITORS_META = {
  eyebrow: 'Local Market Intelligence',
  titleLead: 'All',
  titleAccent: 'competitors',
  description:
    'ELVA automatically discovers and monitors competing dental practices within your market radius — tracking their distance, threat level, reviews, and active ad spend so you always know who you are up against.',
} as const;

/** Practice-type chip styling, keyed by classification. */
export const CMP_TYPE_STYLES: Record<CmpPracticeType, CmpTypeStyle> = {
  'Corporate DSO': { tone: 'terra' },
  'Group Practice': { tone: 'gold' },
  Private: { tone: 'info' },
  'Solo Practice': { tone: 'neutral' },
};
